module.exports = __webpack_public_path__ + "media/images/3img-7ff79b422aae90981c7cd86c1ca925c4.jpg";